import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authProcess } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    // Pulisci subito l'hash dall'URL per evitare che resti dopo refresh
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);
    // Clean URL immediately (prima che qualunque errore lasci il fragment visibile)
    window.history.replaceState({}, "", "/dashboard");
    (async () => {
      try {
        const user = await authProcess(sid);
        setUser(user);  // propaga user all'AuthContext in modo che <Protected> veda la sessione
        navigate("/dashboard", { replace: true });
      } catch (_e) {
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFC]">
      <div className="text-slate-600 text-sm">Autenticazione in corso…</div>
    </div>
  );
}
